import ImageWidget from "../../../widgetsExtend/ImageWidget/widget";
import {WidgetType} from "../../../constants/WidgetConstants";

class AtImageWidget extends ImageWidget{
  static getWidgetType(): WidgetType {
    return "AT_IMAGE_WIDGET";
  }
}
export default AtImageWidget;
